import { render, staticRenderFns } from "./part-orders.vue?vue&type=template&id=91b56d5c&scoped=true"
import script from "./part-orders.vue?vue&type=script&lang=js"
export * from "./part-orders.vue?vue&type=script&lang=js"
import style0 from "./part-orders.vue?vue&type=style&index=0&id=91b56d5c&prod&lang=css"
import style1 from "./part-orders.vue?vue&type=style&index=1&id=91b56d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b56d5c",
  null
  
)

export default component.exports